module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAA9UlEQVR42u3aMQrCQBCF4T2A4GHtTGXrVTyAYGPhASQ5gJVErLQQBJuRLJgqVXyzG91/YGBJ8Qgfu8sEEswslNwBAAAAAAAAAAAAAAAACgcIi6OV1AAAAAAAAAAAAAAAAAAAAJ/+upr2GdurxPl6gNXuEturxPk6gE19s9my7rfXvGriM1U55Wt3wOH06F+wW6vLIV8LsN5frdq2sbu1+kyPyU8KcL6/BteqMz0mP/klOJU7Y/IAKe6MLADeZ/qv5gDvO4M5gDngB+aAzPn554DM+XwOAwAAAAAAAAAAAAAAAAAA8KMkAAAAAAAAAAAAAAAAlNVvv9JCuNo7+R0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/Honduras.png
// module id = V4sH
// module chunks = 0 62 63